import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export type Language = 'ar' | 'en' | 'fr'
export type Direction = 'rtl' | 'ltr'

// Language configuration with direction mapping
export const languageConfig: Record<Language, { direction: Direction; locale: string }> = {
  ar: { direction: 'rtl', locale: 'ar-SA' },
  en: { direction: 'ltr', locale: 'en-US' },
  fr: { direction: 'ltr', locale: 'fr-FR' },
}

interface LanguageState {
  language: Language
  direction: Direction
  locale: string
  setLanguage: (lang: Language) => void
  toggleLanguage: () => void
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => {
      // Initialize with default language config
      const defaultLang: Language = 'ar'
      const defaultConfig = languageConfig[defaultLang]
      
      return {
        language: defaultLang,
        direction: defaultConfig.direction,
        locale: defaultConfig.locale,
        setLanguage: (lang) => {
          const config = languageConfig[lang]
          set({ 
            language: lang, 
            direction: config.direction,
            locale: config.locale
          })
        },
        toggleLanguage: () => {
          const state = get()
          const languages: Language[] = ['ar', 'en', 'fr']
          const currentIndex = languages.indexOf(state.language)
          const nextIndex = (currentIndex + 1) % languages.length
          const newLang = languages[nextIndex]
          const config = languageConfig[newLang]
          set({ 
            language: newLang,
            direction: config.direction,
            locale: config.locale
          })
        },
      }
    },
    {
      name: 'language-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        // Ensure direction and locale are set correctly on rehydration
        if (state) {
          const config = languageConfig[state.language]
          if (state.direction !== config.direction || state.locale !== config.locale) {
            state.direction = config.direction
            state.locale = config.locale
          }
        }
      },
    }
  )
)




